
export default {
  name: 'BaseCard',
  props: {
    blok: {
      type: Object,
      required: true
    }
  },
  computed: {
    classes() {
      const classes = [];
      if (this.blok.background) {
        classes.push(this.blok.background);
      }
      if (this.blok.border) {
        classes.push(this.blok.border);
      }
      if (this.blok.spacing) {
        classes.push(this.blok.spacing);
      }
      return classes;
    }
  }
}
